<div class="confirm-dismiss-diloag" *ngIf="!data?.isCustomizedConfirmationBox">
  <div [class]="data.styleTopHeaderIcon" [hidden]="!data.styleTopHeaderIcon">
    <i [class]="data.topHeaderIcon"></i>
  </div>
  <div class="confirm-dialog-header flex-between-center">
    <h4 [class]="data.styleClassHeading + ' flex-start-center'"
      [ngClass]="{ 'confirm-dismiss-dialog-heading mb-0': true }">
      <span *ngIf="headerIcon" class="mr-2 flex-center-center"
        [ngClass]="[headerIconType ? headerIconType : headerIconPrimary ? 'header-icon-primary' : 'header-icon-warning']">
        <i [class]="headerIcon"></i>
      </span>

      <span>
        {{ data?.title }}
      </span>
    </h4>
    <i *ngIf="!isCloseButtonHidden" class="fal fa-times close-icon pointer" (click)="closeDialog(false, 'close')"></i>
  </div>

  <div class="confirm-dismiss-dialog-content font-ligh font-12 subtitle" [hidden]="!data?.subTitle">
    {{ data?.subTitle }}
  </div>

  <div class="confirm-dismiss-dialog-content font-12" [hidden]="data?.isHTML" [ngClass]="data.styleClassMessage">
    {{ data?.message }}
  </div>

  <div class="confirm-dismiss-dialog-content font-12" [innerHTML]="data?.message" [hidden]="!data?.isHTML"></div>

  <div *ngIf="showFooter" [ngClass]="data.styleFooter" class="confirm-dismiss-dialog-footer flex-end-center">
    <button id="dialog-btn-cancel" *ngIf="data?.button?.cancel?.title" (click)="closeDialog(false, 'cancel')"
      class="btn btn-border pointer btn-submit mr-2 {{ data?.button?.cancel?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.cancel?.backgroundColor ? data?.button?.cancel?.backgroundColor : '#ffffff',
        color: data?.button?.cancel?.color ? data?.button?.cancel?.color : '#333333'
      }">
      {{ data?.button?.cancel?.title }}
    </button>

    <button id="dialog-btn-dismiss" *ngIf="data?.button?.discard?.title" (click)="closeDialog(false, 'discard')"
      class="btn btn-border mr-2 {{ data?.button?.discard?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.discard?.backgroundColor ? data?.button?.discard?.backgroundColor : '#ffffff',
        color: data?.button?.discard?.color ? data?.button?.discard?.color : '#333333',
        'border': data?.button?.discard?.border ? data?.button?.discard?.border : '1px solid #333333'
      }">
      {{ data?.button?.discard?.title }}
    </button>

    <button id="dialog-btn-success" type="submit" *ngIf="data?.button?.success?.title" appAutofocus
      (click)="closeDialog(true, 'success')" class="btn btn-primary {{ data?.button?.success?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.success?.backgroundColor ? data?.button?.success?.backgroundColor : '#00c19f',
        color: data?.button?.success?.color ? data?.button?.success?.color : '#ffffff',
        'border': data?.button?.discard?.border ? data?.button?.discard?.border : '1px solid #333333'
      }">
      <i *ngIf="data.saveBtnIcon" [ngClass]="data.saveBtnIcon"> </i>
      {{ data?.button?.success?.title }}
    </button>
  </div>
</div>

<div class="confirm-dismiss-diloag-customized" *ngIf="data?.isCustomizedConfirmationBox">
  <div [class]="data?.styleTopHeaderIcon" [hidden]="!data?.styleTopHeaderIcon">
    <i [class]="data?.topHeaderIcon"></i>
  </div>
  <div class="confirm-dialog-header flex-between-center border-bottom-lightest">
    <div class="flex-start-center confirm-dismiss-dialog-heading mb-0">
      <span *ngIf="headerIcon" class="mr-2 flex-center-center"
        [ngClass]="[headerIconType ? headerIconType : headerIconPrimary ? 'header-icon-primary' : 'header-icon']">
        <i [class]="headerIcon"></i>
      </span>

      <span [ngClass]="data?.styleClassHeading">
        {{ data?.title }}
      </span>
    </div>
    <span class="pointer" *ngIf="!isCloseButtonHidden" (click)="closeDialog(false, 'close')">
      <i class="fal fa-times pointer" [ngClass]="data?.styleClassCloseIcon"></i>
    </span>

  </div>

  <div class="confirm-dismiss-dialog-content font-12" [hidden]="data?.isHTML" [ngClass]="data.styleClassMessage">
    {{ data?.message }}
  </div>

  <div class="confirm-dismiss-dialog-content font-12">
    <div  [innerHTML]="data?.message" [hidden]="!data?.isHTML"></div>
    <div *ngIf="isShowInputField">
      <app-input theme="light" placeholder="Type ''Confirm'' to proceed" [value]="confirmationText"
      (appChange)="handleChange($event)"></app-input>
    </div>
  </div>
  
  <div *ngIf="showFooter" [ngClass]="data.styleFooter"
    class="confirm-dismiss-dialog-footer border-top-lightest flex-end-center">
    <button id="dialog-btn-cancel" *ngIf="data?.button?.cancel?.title" (click)="closeDialog(false, 'cancel')"
      class="btn btn-border pointer btn-submit mr-2 {{ data?.button?.cancel?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.cancel?.backgroundColor ? data?.button?.cancel?.backgroundColor : '#ffffff',
        color: data?.button?.cancel?.color ? data?.button?.cancel?.color : '#333333'
      }">
      {{ data?.button?.cancel?.title }}
    </button>

    <button id="dialog-btn-dismiss" *ngIf="data?.button?.discard?.title" (click)="closeDialog(false, 'discard')"
      class="btn btn-border mr-2 {{ data?.button?.discard?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.discard?.backgroundColor ? data?.button?.discard?.backgroundColor : '#ffffff',
        color: data?.button?.discard?.color ? data?.button?.discard?.color : '#333333',
        'border': data?.button?.discard?.border ? data?.button?.discard?.border : '1px solid #333333'
      }">
      {{ data?.button?.discard?.title }}
    </button>

    <button id="dialog-btn-success" type="submit" *ngIf="data?.button?.success?.title" appAutofocus
      (click)="closeDialog(true, 'success')" class="btn app-btn-primary {{ data?.button?.success?.styleClass }}" [ngStyle]="{
        'background-color': data?.button?.success?.backgroundColor ? data?.button?.success?.backgroundColor : '#00c19f',
        color: data?.button?.success?.color ? data?.button?.success?.color : '#ffffff',
        'border': data?.button?.discard?.border ? data?.button?.discard?.border : '1px solid #333333'
      }">
      <i *ngIf="data.saveBtnIcon" [ngClass]="data.saveBtnIcon"> </i>
      {{ data?.button?.success?.title }}
    </button>

    <button id="dialog-btn-success" type="submit" *ngIf="data?.button?.proceed?.title" [ngClass]="{'not-allowed disabled': !isValid}"  [disabled]="!isValid"
    appAutofocus
     (click)="closeDialog(true, 'success')" class="btn btn-primary {{ data?.button?.proceed?.styleClass }}" [ngStyle]="{
       'background-color': data?.button?.proceed?.backgroundColor ? data?.button?.proceed?.backgroundColor : '#00c19f',
       color: data?.button?.proceed?.color ? data?.button?.proceed?.color : '#ffffff',
       'border': data?.button?.discard?.border ? data?.button?.discard?.border : '1px solid #333333'
     }" >
     <i *ngIf="data.saveBtnIcon" [ngClass]="data.saveBtnIcon"> </i>
     {{ data?.button?.proceed?.title }}
   </button>
  </div>
</div>
